"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  MULTI_CLOUD_PROXY_HEADER_QUERY_KEY: () => MULTI_CLOUD_PROXY_HEADER_QUERY_KEY,
  MULTI_CLOUD_PROXY_HEADER_SESSION_STORAGE_KEY: () => MULTI_CLOUD_PROXY_HEADER_SESSION_STORAGE_KEY,
  MessageSDK: () => MessageSDK,
  Metrics: () => Metrics,
  RouteOrigin: () => RouteOrigin,
  VolcengineEmbedMetricsEventName: () => VolcengineEmbedMetricsEventName,
  createMessageSDK: () => createMessageSDK,
  generateRegionPathnameByPathname: () => generateRegionPathnameByPathname,
  generateRegionRootPathnameByPathname: () => generateRegionRootPathnameByPathname,
  navigateToRegion: () => navigateToRegion,
  parseJwt: () => parseJwt,
  parseVolcRawRegionFromPathname: () => parseVolcRawRegionFromPathname,
  parseVolcRegion: () => parseVolcRegion,
  proxyService: () => proxyService,
  readMultiCloudProxyHeaderSearchQuery: () => readMultiCloudProxyHeaderSearchQuery,
  recordFcp: () => recordFcp,
  recordLcp: () => recordLcp,
  refreshJwtSdkCache: () => refreshJwtSdkCache,
  serviceNameMap: () => serviceNameMap,
  writeMultiCloudProxyHeaderSearchQuery: () => writeMultiCloudProxyHeaderSearchQuery
});
module.exports = __toCommonJS(src_exports);

// src/config.ts
var MULTI_CLOUD_PROXY_HEADER_SESSION_STORAGE_KEY = "MULTI_CLOUD_PROXY_HEADER_SESSION";
var MULTI_CLOUD_PROXY_HEADER_QUERY_KEY = "x-cloud-volc-mcp-headers";
var NATIVE_SESSION_STORAGE = window.__NATIVE_SESSION_STORAGE__ = window.sessionStorage;
var NATIVE_LOCAL_STORAGE = window.__NATIVE_LOCAL_STORAGE__ = window.localStorage;

// src/url.ts
var import_lodash = __toESM(require("lodash.merge"));
var getHref = (input) => {
  if (typeof input === "string") {
    return input;
  } else if (input instanceof URL) {
    return input.href;
  } else if (input instanceof Request) {
    return input.url;
  }
  throw new Error("handle url failed");
};
var runHeaders = (content, callback) => {
  Object.entries(content).forEach(([key, value]) => {
    if (value) {
      callback(key, value);
    }
  });
};
function getMergedBody(body, mergeBody) {
  try {
    if (typeof body === "string" && mergeBody) {
      return JSON.stringify((0, import_lodash.default)(JSON.parse(body || "{}"), mergeBody));
    }
    return body;
  } catch (e) {
    return body;
  }
}
function isJsonBody(body) {
  return typeof body === "string" && body.startsWith("{") && body.endsWith("}");
}
var generateRequest = async (url, [input, init], mergeBody) => {
  var _a;
  if (input instanceof Request) {
    const originalRequest = new Request(input, init);
    const originalBody = isJsonBody(originalRequest.body) ? await ((_a = originalRequest == null ? void 0 : originalRequest.clone()) == null ? void 0 : _a.text()) : init == null ? void 0 : init.body;
    const body2 = getMergedBody(originalBody, mergeBody);
    return [new Request(url, {
      body: body2,
      mode: originalRequest.mode,
      credentials: originalRequest.credentials,
      cache: originalRequest.cache,
      headers: originalRequest.headers,
      integrity: originalRequest.integrity,
      method: originalRequest.method,
      redirect: originalRequest.redirect,
      referrer: originalRequest.referrer,
      referrerPolicy: originalRequest.referrerPolicy,
      keepalive: originalRequest.keepalive,
      signal: originalRequest.signal
    }), body2];
  }
  const body = getMergedBody(init == null ? void 0 : init.body, mergeBody);
  return [new Request(url, { ...init, body }), body];
};

// src/proxy.ts
var autoProxyHostname = [/^(?!res\.volccdn\.com$)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.volccdn\.com$/];
function getTemplateValue(value, originURL) {
  if (value === "$hostname") {
    return new URL(originURL).hostname;
  }
  return value;
}
function safeSetFetchRequestHeader(target, key, value) {
  try {
    target.headers.set(key, value);
  } catch (error) {
    console.error(error);
  }
}
function safeSetXHRRequestHeader(target, key, value) {
  try {
    const reqHeaders = target._reqHeaders || {};
    if (reqHeaders[key] === value) {
      return;
    }
    target.setRequestHeader(key, value);
  } catch (error) {
    console.error(error);
  }
}
var ProxyService = class {
  constructor() {
    __publicField(this, "_isInit", false);
    __publicField(this, "onFetchResponse");
    __publicField(this, "onXhrEnd");
    __publicField(this, "getMatchedURLRule", (url) => this._urlRules.find((urlRule) => {
      try {
        return urlRule.searchValue instanceof RegExp && urlRule.searchValue.test(url);
      } catch (e) {
        console.error("[Proxy Service]run cb error", e);
        return false;
      }
    }));
    __publicField(this, "_headerRules", []);
    __publicField(this, "_urlRules", []);
    __publicField(this, "_responseRules", []);
    __publicField(this, "_mergeBodyRules", []);
    __publicField(this, "getMatchedHeaderRules", (url) => this._headerRules.filter((headerRule) => {
      try {
        return headerRule.matcher instanceof RegExp && headerRule.matcher.test(url);
      } catch (e) {
        console.error("[Proxy Service]run cb error", e);
        return false;
      }
    }));
    __publicField(this, "getProxyFetch", () => {
      const proxyFetch = new Proxy(fetch, {
        apply: async (_fetch, ctx, args) => {
          var _a;
          try {
            const originURL = getHref(args[0]);
            const mergeBody = (_a = this.matchedMergeBodyRule(originURL)) == null ? void 0 : _a.body;
            const { targetURL, addedHeaders } = this.rewriteURL(originURL);
            const [targetRequest, reqBody] = await generateRequest(targetURL, args, mergeBody);
            if (targetURL !== originURL) {
              safeSetFetchRequestHeader(targetRequest, "x-bcgw-hijack-origin-url", originURL);
              safeSetFetchRequestHeader(targetRequest, "x-bcgw-hijack-referrer", location.href);
            }
            const matchedHeaderRules = this.getMatchedHeaderRules(targetURL);
            matchedHeaderRules.forEach((headerRule) => {
              runHeaders(headerRule.headers, (key, value) => {
                safeSetFetchRequestHeader(targetRequest, key, getTemplateValue(value, originURL));
              });
            });
            if (addedHeaders) {
              runHeaders(addedHeaders, (key, value) => {
                safeSetFetchRequestHeader(targetRequest, key, getTemplateValue(value, originURL));
              });
            }
            const response = await Reflect.apply(_fetch, ctx, [targetRequest]);
            const responseRule = this.matchedResponseRule(targetURL);
            if (this.onFetchResponse && responseRule) {
              try {
                await this.onFetchResponse(
                  {
                    url: targetRequest.url,
                    method: targetRequest.method,
                    body: reqBody == null ? void 0 : reqBody.toString(),
                    headers: targetRequest.headers
                  },
                  response,
                  responseRule.uniqueKey
                );
              } catch (error) {
                console.error(error);
              }
            }
            return response;
          } catch (error) {
            console.error(error);
            return Reflect.apply(_fetch, ctx, args);
          }
        }
      });
      return proxyFetch;
    });
    __publicField(this, "getProxyXhrOpen", () => {
      const proxyXhrOpen = new Proxy(XMLHttpRequest.prototype.open, {
        apply: (_open, ctx, args) => {
          const originURL = getHref(args[1]);
          const { targetURL, addedHeaders } = this.rewriteURL(originURL);
          args[1] = targetURL;
          Reflect.apply(_open, ctx, [...args]);
          ctx._originURL = originURL;
          ctx.addEventListener("loadend", () => {
            const originURL2 = getHref(ctx.responseURL);
            const responseRule = this.matchedResponseRule(originURL2);
            if (this.onXhrEnd && responseRule) {
              this.onXhrEnd(ctx, responseRule.uniqueKey);
            }
          });
          if (originURL !== targetURL) {
            safeSetXHRRequestHeader(ctx, "x-bcgw-hijack-origin-url", originURL);
            safeSetXHRRequestHeader(ctx, "x-bcgw-hijack-referrer", location.href);
          }
          this.getMatchedHeaderRules(targetURL).forEach((headerRule) => {
            runHeaders(headerRule.headers, (key, value) => {
              safeSetXHRRequestHeader(ctx, key, getTemplateValue(value, originURL));
            });
          });
          if (addedHeaders) {
            runHeaders(addedHeaders, (key, value) => {
              safeSetXHRRequestHeader(ctx, key, getTemplateValue(value, originURL));
            });
          }
        }
      });
      return proxyXhrOpen;
    });
    __publicField(this, "getProxyXhrSend", () => {
      const proxyXhrSend = new Proxy(XMLHttpRequest.prototype.send, {
        apply: (_send, ctx, args) => {
          var _a;
          const body = args[0];
          const originURL = getHref(ctx._originURL);
          const responseRule = this.matchedResponseRule(originURL);
          if (responseRule) {
            ctx._reqBody = body;
          }
          if (typeof body === "string" && body.startsWith("{")) {
            try {
              const mergeBody = (_a = this.matchedMergeBodyRule(originURL)) == null ? void 0 : _a.body;
              if (mergeBody) {
                const bodyObj = JSON.parse(body);
                const newBody = {
                  ...bodyObj,
                  ...mergeBody
                };
                return Reflect.apply(_send, ctx, [JSON.stringify(newBody)]);
              }
            } catch (e) {
              console.error("[bytecloud-volc-lib:proxy] merge body error", e);
            }
          }
          return Reflect.apply(_send, ctx, [...args]);
        }
      });
      return proxyXhrSend;
    });
  }
  init() {
    if (this._isInit) {
      return;
    }
    this._isInit = true;
    try {
      window.fetch = this.getProxyFetch();
      window.XMLHttpRequest.prototype.open = this.getProxyXhrOpen();
      window.XMLHttpRequest.prototype.send = this.getProxyXhrSend();
    } catch (e) {
      console.error("[Proxy Service]init error", e);
    }
  }
  addHeaderRule(headerRule) {
    this._headerRules.push(headerRule);
  }
  addSerializableHeaderRule(headerRule) {
    this._headerRules.push({
      matcher: new RegExp(headerRule.matcher),
      uniqueKey: headerRule.uniqueKey,
      headers: headerRule.headers
    });
  }
  uniqueAddSerializableHeaderRule(headerRule) {
    if (headerRule.uniqueKey) {
      this.removeHeaderRuleWithUniqueKey(headerRule.uniqueKey);
    }
    this.addSerializableHeaderRule(headerRule);
  }
  addURLRule(urlRule) {
    this._urlRules.push(urlRule);
  }
  addSerializableURLRule(urlRule) {
    this._urlRules.push({
      uniqueKey: urlRule.uniqueKey,
      searchValue: new RegExp(urlRule.searchValue),
      replaceValue: urlRule.replaceValue,
      ignoreValue: urlRule.ignoreValue ? new RegExp(urlRule.ignoreValue) : void 0,
      addedHeaders: urlRule.addedHeaders
    });
  }
  uniqueAddSerializableURLRule(urlRule) {
    if (urlRule.uniqueKey) {
      this.removeURLRuleWithUniqueKey(urlRule.uniqueKey);
    }
    this.addSerializableURLRule(urlRule);
  }
  addSerializableMergeBodyRule(mergeBodyRule) {
    this._mergeBodyRules.push({
      uniqueKey: mergeBodyRule.uniqueKey,
      searchValue: new RegExp(mergeBodyRule.searchValue),
      ignoreValue: mergeBodyRule.ignoreValue ? new RegExp(mergeBodyRule.ignoreValue) : void 0,
      body: JSON.parse(mergeBodyRule.body)
    });
  }
  uniqueAddSerializableMergeBodyRule(mergeBodyRule) {
    if (mergeBodyRule.uniqueKey) {
      this.removeMergeBodyRuleWithUniqueKey(mergeBodyRule.uniqueKey);
    }
    this.addSerializableMergeBodyRule(mergeBodyRule);
  }
  removeMergeBodyRuleWithUniqueKey(uniqKey) {
    this._mergeBodyRules = this._mergeBodyRules.filter((item) => item.uniqueKey !== uniqKey);
  }
  removeURLRuleWithUniqueKey(uniqKey) {
    this._urlRules = this._urlRules.filter((item) => item.uniqueKey !== uniqKey);
  }
  removeHeaderRuleWithUniqueKey(uniqKey) {
    this._headerRules = this._headerRules.filter((item) => item.uniqueKey !== uniqKey);
  }
  addSerializableResponseRule(responseRule) {
    this._responseRules.push({
      uniqueKey: responseRule.uniqueKey,
      searchValue: new RegExp(responseRule.searchValue),
      ignoreValue: responseRule.ignoreValue ? new RegExp(responseRule.ignoreValue) : void 0
    });
  }
  uniqueAddSerializableResponseRule(responseRule) {
    if (responseRule.uniqueKey) {
      this.removeResponseRuleWithUniqueKey(responseRule.uniqueKey);
    }
    this.addSerializableResponseRule(responseRule);
  }
  removeResponseRuleWithUniqueKey(uniqKey) {
    this._responseRules = this._responseRules.filter((item) => item.uniqueKey !== uniqKey);
  }
  resetURLRule() {
    this._urlRules = [];
  }
  resetHeaderRule() {
    this._headerRules = [];
  }
  rewriteURL(url) {
    if (typeof url === "string") {
      const urlRule = this._urlRules.find((item) => {
        var _a;
        return item.searchValue.test(url) && !((_a = item.ignoreValue) == null ? void 0 : _a.test(url));
      });
      if (urlRule) {
        try {
          return {
            targetURL: urlRule.replaceValue ? url.replace(urlRule.searchValue, urlRule.replaceValue) : url,
            addedHeaders: urlRule.addedHeaders
          };
        } catch (error) {
          console.error(error);
        }
      } else {
        return this.autoRewriteURLRule(url);
      }
    }
    return {
      targetURL: url
    };
  }
  autoRewriteURLRule(url) {
    const urlObj = new URL(url.startsWith("/") ? `${location.origin}${url}` : url);
    const isSameOrigin = urlObj.hostname === location.hostname;
    const isInWhitelist = autoProxyHostname.some((hostname) => hostname.test(urlObj.hostname));
    const addedHeaders = {};
    if (isSameOrigin || isInWhitelist) {
      try {
        const proxySession = sessionStorage.getItem(MULTI_CLOUD_PROXY_HEADER_SESSION_STORAGE_KEY);
        if (proxySession) {
          addedHeaders[MULTI_CLOUD_PROXY_HEADER_QUERY_KEY] = proxySession;
        }
      } catch (e) {
        console.error(e);
      }
      if (isInWhitelist) {
        const originHostname = urlObj.hostname;
        return {
          targetURL: urlObj.pathname + urlObj.search,
          addedHeaders: {
            ...addedHeaders,
            "x-bcgw-volc-sign-hostname": originHostname
          }
        };
      }
    }
    return {
      targetURL: url,
      addedHeaders
    };
  }
  matchedResponseRule(url) {
    if (typeof url === "string") {
      const responseRule = this._responseRules.find(
        (item) => {
          var _a;
          return item.searchValue.test(url) && !((_a = item.ignoreValue) == null ? void 0 : _a.test(url));
        }
      );
      if (responseRule) {
        return responseRule;
      }
    }
    return void 0;
  }
  matchedMergeBodyRule(url) {
    if (typeof url === "string") {
      const mergeBodyRule = this._mergeBodyRules.find(
        (item) => {
          var _a;
          return item.searchValue.test(url) && !((_a = item.ignoreValue) == null ? void 0 : _a.test(url));
        }
      );
      if (mergeBodyRule) {
        return mergeBodyRule;
      }
    }
    return void 0;
  }
};
var proxyService = new ProxyService();

// src/jwt.contant.ts
var JwtStorageKey = "__cloud_jwt";
var MappedJwtStorageKey = "CLOUD_JWT_MAP";
var VolcMappedJwtStorageKey = "VOLC_CLOUD_JWT_MAP";

// src/util.ts
function deleteSdkJwtLocalStorage() {
  NATIVE_LOCAL_STORAGE.removeItem(JwtStorageKey);
  NATIVE_LOCAL_STORAGE.removeItem(MappedJwtStorageKey);
}
var hasWindow = typeof window !== "undefined";
var initJwtPromiseCache = () => {
  try {
    if (hasWindow) {
      if (!window.__bytecloud_shared__) {
        window.__bytecloud_shared__ = {};
      }
      if (!window.__bytecloud_shared__.jwtPromisesCache) {
        window.__bytecloud_shared__.jwtPromisesCache = {};
      }
      return window.__bytecloud_shared__.jwtPromisesCache;
    } else {
      return {};
    }
  } catch (error) {
    return {};
  }
};
function writeMultiCloudProxyHeaderSearchQuery(query) {
  NATIVE_SESSION_STORAGE.setItem(MULTI_CLOUD_PROXY_HEADER_SESSION_STORAGE_KEY, query);
}
function readMultiCloudProxyHeaderSearchQuery() {
  return NATIVE_SESSION_STORAGE.getItem(MULTI_CLOUD_PROXY_HEADER_SESSION_STORAGE_KEY);
}
function refreshJwtSdkCache(jwtList) {
  const jwtPromisesCache = initJwtPromiseCache();
  let fromCache = false;
  if (!jwtList) {
    try {
      jwtList = readJwtLocalStorage();
      fromCache = true;
    } catch (e) {
    }
    if (!jwtList) {
      return false;
    }
  }
  if (!Array.isArray(jwtList)) {
    return false;
  }
  if (fromCache) {
    writeJwtLocalStorage(jwtList);
  }
  jwtList.forEach((info) => {
    jwtPromisesCache[info.uniqueKey] = Promise.resolve(info.jwt);
  });
  deleteSdkJwtLocalStorage();
  return true;
}
function writeJwtLocalStorage(jwtList) {
  NATIVE_LOCAL_STORAGE.setItem(VolcMappedJwtStorageKey, JSON.stringify(jwtList));
}
function readJwtLocalStorage() {
  const storageValue = NATIVE_LOCAL_STORAGE.getItem(VolcMappedJwtStorageKey);
  if (storageValue) {
    return JSON.parse(storageValue);
  }
}
function parseJwt(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window.atob(base64).split("").map(function(c) {
      return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
    }).join("")
  );
  return JSON.parse(jsonPayload);
}
function getHeaders(headers) {
  const result = {};
  headers.forEach((value, key) => {
    result[key] = value;
  });
  return result;
}
function parseStringHeader(header) {
  const result = {};
  header.split("\n").forEach((item) => {
    const [key, value] = item.split(":");
    if (key && value) {
      result[key.trim()] = value.trim();
    }
  });
  return result;
}
var docsUrlCache = /* @__PURE__ */ new Map();
async function getVolcDocsURL(url) {
  try {
    if (docsUrlCache.has(url)) {
      return docsUrlCache.get(url);
    }
    const response = await fetch(
      `https://cloud.bytedance.net/api/v1/cloud_developer/api/open/v1/link?url=${encodeURIComponent(url)}`
    );
    const body = await response.json();
    const docUrl = body.data.doc_url || url;
    docsUrlCache.set(url, docUrl);
    return docUrl;
  } catch (e) {
    return url;
  }
}

// src/message.ts
var import_debug = __toESM(require("debug"));
var import_qs = __toESM(require("qs"));
var log = (0, import_debug.default)("bytecloud-volc-lib:message");
var clientEventPrefix = "volc_2_bytecloud_event";
var serverEventPrefix = "bytecloud_2_volc_event";
function handleURL(url) {
  if (typeof url === "string") {
    return url;
  }
  if (url instanceof URL) {
    return url.href;
  }
  return "";
}
function isHTMLAnchorElement(element) {
  return Boolean(element) && element.localName === "a" && element.getAttribute("href") !== null;
}
var RouteOrigin = /* @__PURE__ */ ((RouteOrigin2) => {
  RouteOrigin2["Server"] = "server";
  RouteOrigin2["Client"] = "client";
  return RouteOrigin2;
})(RouteOrigin || {});
function isSDKMessageEventPayload(payload, prefix) {
  return payload.type.indexOf(`${prefix}:`) === 0;
}
function isPathAlreadyNavigated(last, target) {
  if (last.endsWith("/")) {
    last = last.slice(0, -1);
  }
  if (target.endsWith("/")) {
    target = target.slice(0, -1);
  }
  return last.endsWith(target);
}
var defaultOptions = {
  enableHandleClick: true,
  enableHandleOpen: true,
  disableRouteListener: false
};
var MessageSDK = class extends EventTarget {
  constructor(options) {
    super();
    __publicField(this, "receivePrefix");
    __publicField(this, "sendPrefix");
    __publicField(this, "iframe");
    __publicField(this, "messageOrigin");
    __publicField(this, "options");
    __publicField(this, "_lastForwardRoutePath");
    __publicField(this, "fetchListener", async (reqData, res, uniqueKey) => {
      var _a;
      if (this.options.role !== "client") {
        return;
      }
      const clonedRes = res.clone();
      const resBody = ((_a = res.headers.get("content-type")) == null ? void 0 : _a.includes("application/json")) ? await clonedRes.text() : "";
      this.sendMessage("get_response", {
        uniqueKey,
        response: {
          body: resBody,
          status: clonedRes.status,
          headers: getHeaders(clonedRes.headers)
        },
        request: {
          url: reqData.url,
          method: reqData.method,
          headers: getHeaders(reqData.headers),
          body: reqData.body
        }
      });
    });
    __publicField(this, "xhrListener", (xhr, uniqueKey) => {
      if (this.options.role !== "client") {
        return;
      }
      this.sendMessage("get_response", {
        uniqueKey,
        response: {
          body: xhr.responseText,
          status: xhr.status,
          headers: parseStringHeader(xhr.getAllResponseHeaders())
        },
        request: {
          url: xhr.responseURL,
          method: xhr._reqMethod,
          headers: xhr._reqHeaders,
          body: xhr._reqBody
        }
      });
    });
    this.options = { ...defaultOptions, ...options };
    this.iframe = this.options.iframe;
    this.messageOrigin = this.options.messageOrigin || "*";
    if (this.options.role === "client") {
      this.receivePrefix = serverEventPrefix;
      this.sendPrefix = clientEventPrefix;
      this.initClient();
      proxyService.init();
      proxyService.onFetchResponse = this.fetchListener;
      proxyService.onXhrEnd = this.xhrListener;
    } else {
      this.receivePrefix = clientEventPrefix;
      this.sendPrefix = serverEventPrefix;
    }
    window.addEventListener("message", (event) => {
      var _a;
      if ((!this.iframe || event.source === ((_a = this.iframe) == null ? void 0 : _a.contentWindow)) && (event.origin === this.messageOrigin || this.messageOrigin === "*") && typeof event.data === "string") {
        try {
          const payload = JSON.parse(event.data);
          if (isSDKMessageEventPayload(payload, this.receivePrefix)) {
            const miniType = payload.type.replace(`${this.receivePrefix}:`, "");
            log(`[${this.options.role}] receive message: [${miniType}] data: ${JSON.stringify(payload.data)}`);
            this.dispatchEvent(new CustomEvent(miniType, { detail: { ...payload.data, originEvent: event } }));
          }
        } catch (e) {
        }
      }
    });
  }
  initClient() {
    window.__MESSAGE_CLIENT_INIT__ = true;
    const originPushState = window.history.pushState.bind(window.history);
    const originReplaceState = window.history.replaceState.bind(window.history);
    const originForward = window.history.forward.bind(window.history);
    const originGo = window.history.go.bind(window.history);
    const originOpen = window.open.bind(window);
    const handleRoute = (routeData) => {
      var _a, _b, _c, _d, _e;
      if (routeData.mode === "open") {
        if (routeData.url && this._lastForwardRoutePath && isPathAlreadyNavigated(this._lastForwardRoutePath, routeData.url)) {
          this._lastForwardRoutePath = void 0;
          return;
        }
      }
      if (typeof routeData.url === "string" && routeData.url.startsWith("//")) {
        routeData.url = `${window.location.protocol}${routeData.url}`;
      }
      this.sendMessage("route", routeData);
      switch (routeData.mode) {
        case "pushState":
          this._lastForwardRoutePath = routeData.url;
          originPushState((_a = routeData.args) == null ? void 0 : _a[0], ((_b = routeData.args) == null ? void 0 : _b[1]) || "", routeData.url);
          break;
        case "replaceState": {
          const url = handleReplaceStateSearch(routeData.url);
          this._lastForwardRoutePath = routeData.url;
          originReplaceState((_c = routeData.args) == null ? void 0 : _c[0], ((_d = routeData.args) == null ? void 0 : _d[1]) || "", url);
          break;
        }
        case "back":
          originGo(-1);
          break;
        case "forward":
          originForward();
          break;
        case "open":
          if (!routeData.target && ((_e = routeData.url) == null ? void 0 : _e.startsWith("/"))) {
            originOpen(routeData.url, "_self", routeData.features);
          }
          if (!this.options.enableHandleOpen && routeData.url) {
            getVolcDocsURL(routeData.url).then((url) => {
              originOpen(url, routeData.target, routeData.features);
            });
          }
          break;
        case "close":
        default:
          break;
      }
    };
    function handleHashChange() {
      const [path, queryString] = window.location.hash.split("?");
      handleRoute({
        mode: "hashchange",
        rawHash: window.location.hash,
        hash: path,
        queryString,
        origin: "client" /* Client */
      });
    }
    if (!this.options.disableRouteListener) {
      window.history.pushState = function(data, unused, url) {
        handleRoute({
          url: handleURL(url),
          mode: "pushState",
          args: [data, unused],
          origin: "client" /* Client */
        });
      };
      window.history.replaceState = (data, unused, url) => {
        handleRoute({
          url: handleURL(url),
          mode: "replaceState",
          args: [data, unused],
          origin: "client" /* Client */
        });
      };
      window.history.back = () => {
        handleRoute({ mode: "back", origin: "client" /* Client */ });
      };
      window.history.forward = () => {
        handleRoute({ mode: "forward", origin: "client" /* Client */ });
      };
      window.history.go = (delta) => {
        if (delta === -1) {
          handleRoute({ mode: "back", origin: "client" /* Client */ });
        }
      };
      window.open = (url, target, features) => {
        if (!url && location.hostname.includes("coze")) {
          const newWindow = {};
          return new Proxy(newWindow, {
            set: (targetInstance, prop, value) => {
              if (prop === "location" && typeof value === "string") {
                handleRoute({
                  mode: "open",
                  url: handleURL(value),
                  target: target || "_blank",
                  features,
                  origin: "client" /* Client */
                });
              } else {
                targetInstance[prop] = value;
              }
              return true;
            }
          });
        }
        handleRoute({
          mode: "open",
          url: handleURL(url),
          target: target || "_blank",
          features,
          origin: "client" /* Client */
        });
        return null;
      };
      window.close = () => {
        handleRoute({
          mode: "close",
          origin: "client" /* Client */
        });
      };
      const handleRouteEvent = function(event) {
        const { originEvent } = event.detail;
        function getNewURL(oldURL) {
          const urlObj = new URL(oldURL.startsWith("http") ? oldURL : originEvent.origin + oldURL);
          return urlObj.pathname + urlObj.search;
        }
        const routeData = event.detail;
        if (routeData.mode === "pushState" || routeData.mode === "replaceState") {
          routeData.url = getNewURL(routeData.url);
        }
        handleRoute(routeData);
      };
      this.addEventListener("route", handleRouteEvent);
      const handleClick = (element, e) => {
        if (isHTMLAnchorElement(element)) {
          let url = element.getAttribute("href");
          if (url === this._lastForwardRoutePath) {
            url = null;
          }
          const target = element.getAttribute("target") || void 0;
          if (url !== null) {
            if (!validateOpenURL(url)) {
              if (isHashUrl(url)) {
                if (target === "_blank") {
                  handleRoute({ mode: "open", url: handleURL(url), target, origin: "client" /* Client */ });
                }
              }
              return;
            }
            e.preventDefault();
            setTimeout(() => {
              handleRoute({ mode: "open", url: handleURL(url), target, origin: "client" /* Client */ });
            }, 0);
            return true;
          }
        }
        return false;
      };
      if (this.options.enableHandleClick) {
        document.documentElement.addEventListener("click", (e) => {
          var _a, _b, _c, _d, _e, _f;
          if (!this.options.enableHandleClick) {
            return;
          }
          const target = e.target;
          if (target !== null) {
            const elementList = [
              target,
              target.parentElement,
              (_a = target.parentElement) == null ? void 0 : _a.parentElement,
              (_c = (_b = target.parentElement) == null ? void 0 : _b.parentElement) == null ? void 0 : _c.parentElement,
              (_f = (_e = (_d = target.parentElement) == null ? void 0 : _d.parentElement) == null ? void 0 : _e.parentElement) == null ? void 0 : _f.parentElement
            ];
            elementList.some((ele) => handleClick(ele, e));
          }
        });
      }
      window.addEventListener("hashchange", handleHashChange);
      window.addEventListener("load", () => {
        if (location.hash) {
          handleRoute({
            mode: "hashchange",
            rawHash: window.location.hash,
            // hash: path,
            // queryString,
            origin: "client" /* Client */
          });
        }
      });
    }
    function injectStyle(event) {
      const { id, style } = event.detail;
      const styleElement = document.createElement("style");
      styleElement.setAttribute("class", "bytecloud-inject-style");
      if (typeof id === "string") {
        styleElement.setAttribute("id", id);
      }
      styleElement.innerHTML = style;
      document.head.appendChild(styleElement);
    }
    this.addEventListener("inject_style", injectStyle);
    function injectScript(event) {
      const { id, evalString, src } = event.detail;
      const scriptElement = document.createElement("script");
      scriptElement.setAttribute("class", "bytecloud-inject-script");
      scriptElement.setAttribute("crossorigin", "anonymous");
      scriptElement.setAttribute("type", "text/javascript");
      if (typeof id === "string") {
        scriptElement.setAttribute("id", id);
      }
      if (typeof evalString === "string") {
        scriptElement.innerHTML = evalString;
        document.body.appendChild(scriptElement);
      } else if (typeof src === "string") {
        scriptElement.setAttribute("src", src);
        document.body.appendChild(scriptElement);
      }
    }
    this.addEventListener("inject_script", injectScript);
    const role = this.options.role;
    function proxyAddHeader(event) {
      const rule = event.detail;
      log(`[${role}] adding proxy header: ${JSON.stringify(rule)}`);
      proxyService.uniqueAddSerializableHeaderRule(rule);
    }
    this.addEventListener("proxy_add_header", proxyAddHeader);
    function listenResponse(event) {
      const rule = event.detail;
      log(`[${role}] adding response listener: ${JSON.stringify(rule)}`);
      proxyService.uniqueAddSerializableResponseRule(rule);
    }
    this.addEventListener("listen_response", listenResponse);
    function proxyAddURL(event) {
      const rule = event.detail;
      log(`[${role}] adding proxy url: ${JSON.stringify(rule)}`);
      proxyService.uniqueAddSerializableURLRule(rule);
    }
    this.addEventListener("proxy_add_url", proxyAddURL);
    function proxyMergeBody(event) {
      const rule = event.detail;
      log(`[${role}] adding proxy merge body: ${JSON.stringify(rule)}`);
      proxyService.uniqueAddSerializableMergeBodyRule(rule);
    }
    this.addEventListener("proxy_merge_body", proxyMergeBody);
    function syncJwtListener(event) {
      const { detail } = event;
      if (detail.jwtList) {
        log(`[${role}] refreshing jwt sdk cache.`);
        refreshJwtSdkCache(detail.jwtList);
      }
      if (detail.multiCloudProxyQuery) {
        log(`[${role}] syncing multi cloud proxy query.`);
        try {
          const json = JSON.parse(detail.multiCloudProxyQuery);
          const jwt = json["x-jwt-token"];
          const parsedJwt = parseJwt(jwt);
          if (parsedJwt.exp) {
            const date = new Date(parsedJwt.exp * 1e3);
            log(`[${role}] jwt parsed from multi cloud proxy query, will expire at ${date.toLocaleString()}`);
          }
        } catch (e) {
        }
        writeMultiCloudProxyHeaderSearchQuery(detail.multiCloudProxyQuery);
        const readFromSessionStorage = readMultiCloudProxyHeaderSearchQuery();
        if (readFromSessionStorage !== detail.multiCloudProxyQuery) {
          log(
            `[${role}] multi cloud proxy query is not the same with written storage, there are problem with session storage.`
          );
        }
      }
    }
    this.addEventListener("sync_jwt", syncJwtListener);
    const changeClientOption = (event) => {
      const { detail } = event;
      this.options = { ...this.options, ...detail };
    };
    this.addEventListener("change_client_option", changeClientOption);
    this.sendMessage("init", { mode: "init", url: window.location.pathname + window.location.search });
  }
  sendMessage(type, data) {
    var _a;
    const message = JSON.stringify({ type: `${this.sendPrefix}:${type}`, data });
    log(`[${this.options.role}] send message: [${type}] data: ${JSON.stringify(data)}`);
    if (this.options.role === "server") {
      const iframe = this.iframe || document.querySelector("iframe");
      if (iframe) {
        this.iframe = iframe;
        (_a = iframe.contentWindow) == null ? void 0 : _a.postMessage(message, "*");
      }
    } else {
      if (window.parent) {
        window.parent.postMessage(message, "*");
      }
    }
  }
  addEventListener(type, callback, options) {
    return super.addEventListener(type, callback, options);
  }
  removeEventListener(type, callback, options) {
    return super.removeEventListener(type, callback, options);
  }
};
function createMessageSDK(options) {
  return new MessageSDK(options);
}
function handleReplaceStateSearch(s) {
  if (s.startsWith("?")) {
    const sp = import_qs.default.parse(s, { ignoreQueryPrefix: true });
    const currentSearchParams = import_qs.default.parse(location.search, {
      ignoreQueryPrefix: true
    });
    Object.entries(currentSearchParams).forEach(([key, val]) => {
      if (sp[key] === void 0 && val !== void 0) {
        sp[key] = val;
      }
    });
    return `?${import_qs.default.stringify(sp, { arrayFormat: "repeat" })}`;
  }
  return s;
}
function validateOpenURL(url) {
  if (url.startsWith("/") || url.startsWith("http")) {
    return true;
  }
  return false;
}
function isHashUrl(url) {
  return url.startsWith("#");
}

// src/metrics.ts
var VolcengineEmbedMetricsEventName = /* @__PURE__ */ ((VolcengineEmbedMetricsEventName2) => {
  VolcengineEmbedMetricsEventName2["Init"] = "performance_volcengine_embed_init";
  VolcengineEmbedMetricsEventName2["ProjectPermissionPageReactComponentInit"] = "performance_volcengine_embed_project_permission_page_react_component_init";
  VolcengineEmbedMetricsEventName2["ProjectPermissionChecked"] = "performance_volcengine_embed_project_permission_checked";
  VolcengineEmbedMetricsEventName2["IframeReactComponentInit"] = "performance_volcengine_embed_iframe_react_component_init";
  VolcengineEmbedMetricsEventName2["IframeUrlCreated"] = "performance_volcengine_embed_iframe_url_created";
  VolcengineEmbedMetricsEventName2["IframeSdkInit"] = "performance_volcengine_embed_iframe_sdk_init";
  VolcengineEmbedMetricsEventName2["IframeFCP"] = "performance_volcengine_embed_iframe_fcp";
  VolcengineEmbedMetricsEventName2["IframeLCP"] = "performance_volcengine_embed_iframe_lcp";
  return VolcengineEmbedMetricsEventName2;
})(VolcengineEmbedMetricsEventName || {});
var Metrics = class {
  constructor() {
    __publicField(this, "HTML_START_TIMESTAMP_KEY_NAME");
    __publicField(this, "GLOBAL_WINDOW");
    __publicField(this, "slardarInstance");
    __publicField(this, "htmlInitStart");
    __publicField(this, "reportedKeys", /* @__PURE__ */ new Set());
    __publicField(this, "available", true);
    var _a, _b, _c, _d;
    this.HTML_START_TIMESTAMP_KEY_NAME = Symbol.for("BytecloudStart");
    if (!window.Garfish) {
      console.error(
        "[Metrics] Garfish is not defined. The code should be excuted in a bytecloud platform environment."
      );
      this.available = false;
      return;
    }
    this.GLOBAL_WINDOW = window.Garfish.getGlobalObject();
    if (!((_a = this.GLOBAL_WINDOW) == null ? void 0 : _a.cloud_slardar)) {
      console.error(
        "[Metrics] Bytecloud slardar instance is not found. The code should be excuted in a bytecloud platform environment."
      );
      this.available = false;
    }
    this.slardarInstance = (_b = this.GLOBAL_WINDOW) == null ? void 0 : _b.cloud_slardar;
    if (!((_c = this.GLOBAL_WINDOW) == null ? void 0 : _c[this.HTML_START_TIMESTAMP_KEY_NAME])) {
      console.error(
        '[Metrics] "htmlInitStart" timestamp is not found. The code should be excuted in a bytecloud platform environment.'
      );
      this.available = false;
    }
    this.htmlInitStart = (_d = this.GLOBAL_WINDOW) == null ? void 0 : _d[this.HTML_START_TIMESTAMP_KEY_NAME];
    if (typeof this.htmlInitStart !== "number") {
      console.error(
        '[Metrics] "htmlInitStart" timestamp is not number. The code should be excuted in a bytecloud platform environment.'
      );
      this.available = false;
    }
    if (!this.available) {
      console.error("[Metrics] All performance metrics report will be ignored.");
    }
  }
  fromHtmlInitOnceWithCatchError(options) {
    try {
      this.fromHtmlInitOnce(options);
    } catch (e) {
      console.error("[Metrics] Report performance metrics error:", e);
    }
  }
  fromHtmlInitOnce(options) {
    const { event } = options;
    if (this.reportedKeys.has(event)) {
      return;
    }
    this.reportedKeys.add(event);
    this.fromHtmlInitV2(options);
  }
  fromHtmlInitV2({ event, categories, customEnd, abs }) {
    const end = customEnd && Number(customEnd) > 1e3 ? Number(customEnd) : Date.now();
    if (!this.htmlInitStart) {
      return;
    }
    if (this.htmlInitStart > 1e3) {
      const duration = Math.round(end - this.htmlInitStart);
      const cost = abs ? Math.abs(duration) : duration;
      this.sendSlardarMetricsEvent(event, { cost }, categories);
    }
  }
  sendSlardarMetricsEvent(eventName, metrics, categories) {
    if (this.slardarInstance && this.available) {
      this.slardarInstance.sendEvent({
        name: eventName,
        metrics,
        categories
      });
      return true;
    }
    return false;
  }
};
function recordFcp(cb) {
  const observer = new PerformanceObserver((entryList) => {
    for (const entry of entryList.getEntriesByName("first-contentful-paint")) {
      cb(entry);
    }
  });
  observer.observe({ type: "paint", buffered: true });
  return () => observer.disconnect();
}
function recordLcp(cb) {
  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      cb(entry);
    }
  });
  observer.observe({ type: "largest-contentful-paint", buffered: true });
  return () => observer.disconnect();
}

// src/region.ts
var import_qs2 = __toESM(require("qs"));
var regexp = /^region:([^+:?]+)\+([^+:?]+)/;
function parseVolcRegion(regionPart) {
  if (!regionPart) {
    console.warn("[bc-lib] Region part in url is invalid.");
    return void 0;
  }
  const result = regionPart.match(regexp);
  if (result && result.length > 2) {
    return { region: result[2], platform: result[1], raw: result[0] };
  }
  if (!regionPart) {
    console.warn('[bc-lib] Region part in url cant be recognize in format "region:{platform}+{region}".');
    return void 0;
  }
  return void 0;
}
function parseVolcRawRegionFromPathname(pathname) {
  const splitParts = pathname.split("/");
  const regionPartList = splitParts.filter((p) => p.startsWith("region:"));
  let parsedRegion;
  if (regionPartList.length > 0) {
    parsedRegion = parseVolcRegion(regionPartList[0]);
  }
  const index = splitParts.findIndex((p) => p.startsWith("region:"));
  if (index > 0) {
    let prefix = splitParts.slice(0, index).join("/");
    if (!prefix.endsWith("/")) {
      prefix = `${prefix}/`;
    }
    let suffix = splitParts.slice(index + 1).join("/");
    if (!suffix.startsWith("/")) {
      suffix = `/${suffix}`;
    }
    return { prefix, suffix, parsedRegion };
  }
  throw new Error('[bc-lib] Region part in url cant be recognize in format "region:{platform}+{region}".');
}
function createRawRegion(platform, region) {
  return `region:${platform}+${region}`;
}
function generateRegionPathnameByPathname(pathname, region) {
  const parsed = parseVolcRawRegionFromPathname(pathname);
  if (parsed.parsedRegion) {
    const { platform } = parsed.parsedRegion;
    const rawRegion = createRawRegion(platform, region);
    return `${parsed.prefix}${rawRegion}${parsed.suffix}`;
  }
}
function generateRegionRootPathnameByPathname(pathname, region, rootSuffix = "") {
  const parsed = parseVolcRawRegionFromPathname(pathname);
  if (parsed.parsedRegion) {
    const { platform } = parsed.parsedRegion;
    const rawRegion = createRawRegion(platform, region);
    return `${parsed.prefix}${rawRegion}${rootSuffix}`;
  }
}
function navigateToRegion(region, keepPath = false, rootSuffix = "") {
  let navigatePath;
  if (keepPath) {
    navigatePath = generateRegionPathnameByPathname(location.pathname, region);
  } else {
    navigatePath = generateRegionRootPathnameByPathname(location.pathname, region, rootSuffix);
  }
  if (navigatePath && !location.pathname.startsWith(navigatePath)) {
    const params = import_qs2.default.parse(location.search, { ignoreQueryPrefix: true });
    appendDefaultSearchParams(params);
    const navigatePathWithSearch = `${navigatePath}?${import_qs2.default.stringify(params)}`;
    window.location.href = navigatePathWithSearch;
  }
}
function appendDefaultSearchParams(params) {
  const proxySession = sessionStorage.getItem(MULTI_CLOUD_PROXY_HEADER_SESSION_STORAGE_KEY);
  if (proxySession) {
    params[MULTI_CLOUD_PROXY_HEADER_QUERY_KEY] = proxySession;
  }
  return params;
}

// src/service.ts
var serviceNameMap = {
  livesaas: "企业直播",
  vke: "容器服务",
  vpc: "私有网络/公网IP/NAT网关/VPN连接/私网连接",
  spark: "流式计算 Spark",
  flink: "流式计算 Flink",
  las: "湖仓一体分析服务",
  cloud_detect: "云拨测",
  cloud_monitor: "云监控",
  bytehouse: "Bytehouse 云数仓版",
  cfs: "大数据文件存储",
  vegame: "云游戏",
  rtc: "实时音视频",
  acep: "云手机",
  bytehouse_ce: "Bytehouse 企业版",
  datasail: "全域数据分析",
  live: "视频直播",
  cr: "镜像仓库"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MULTI_CLOUD_PROXY_HEADER_QUERY_KEY,
  MULTI_CLOUD_PROXY_HEADER_SESSION_STORAGE_KEY,
  MessageSDK,
  Metrics,
  RouteOrigin,
  VolcengineEmbedMetricsEventName,
  createMessageSDK,
  generateRegionPathnameByPathname,
  generateRegionRootPathnameByPathname,
  navigateToRegion,
  parseJwt,
  parseVolcRawRegionFromPathname,
  parseVolcRegion,
  proxyService,
  readMultiCloudProxyHeaderSearchQuery,
  recordFcp,
  recordLcp,
  refreshJwtSdkCache,
  serviceNameMap,
  writeMultiCloudProxyHeaderSearchQuery
});
